import React from 'react';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectPrintPDFSections } from './slice/selectors';
import clsx from 'clsx';

export interface PrintPDFSectionProps {
  print: boolean;
  id: string;
  forceChecked?: boolean;
  fullWidth?: boolean;
  sectionClass?: string;
}
export function PrintPDFSection(
  props: React.PropsWithChildren<PrintPDFSectionProps>,
) {
  const printPDFSections = useSelector(selectPrintPDFSections);
  const componentRef = useRef<HTMLDivElement>(null);
  const printClasses = React.useMemo(() => {
    const classes = ['print-section'];
    if (props.fullWidth) {
      classes.push('print-section-full-width');
    }
    let checked = printPDFSections?.some(
      f => f.id === props.id && (f.checked === true || props.forceChecked),
    );
    if (props.print && !checked) {
      classes.push('print-section-hidden');
    } else {
      classes.push('print-section-block');
    }
    return classes.join(' ');
  }, [
    printPDFSections,
    props.forceChecked,
    props.fullWidth,
    props.id,
    props.print,
  ]);
  // useEffect(() => {
  //   if (componentRef.current !== null) {
  //     if (props.print) {
  //       const checked = printPDFSections?.some(
  //         f => f.id === props.id && (f.checked === true || props.forceChecked),
  //       );
  //       if (checked) {
  //         componentRef.current.style.display = 'block';
  //       } else {
  //         componentRef.current.style.display = 'none';
  //       }
  //     } else {
  //       componentRef.current.style.display = 'initial';
  //     }
  //   }
  // }, [printPDFSections, props.forceChecked, props.id, props.print]);
  return (
    <>
      {props.print ? (
        <PrintSection
          className={clsx(printClasses, props.sectionClass)}
          ref={componentRef}
        >
          {props.children}
        </PrintSection>
      ) : (
        <>{props.children}</>
      )}
    </>
  );
}
const PrintSection = styled.div`
  &.print-section {
    display: initial;
    &.print-section-hidden {
      display: none;
    }
    &.print-section-block {
      display: block;
    }
    &.print-section-full-width {
      width: 100%;
    }
    &.print-reservation {
      & .formsection {
        flex-direction: column;
        gap: 32px;
        & .rightsection {
          width: 100%;
        }
      }
    }
  }
`;
